import { assertDefined, ensureDefined, } from '@tymia/shared';
import { prop, } from 'remeda';
import { deDE, } from './de-DE.js';
import { enUS, } from './en-US.js';
const translations = [
    enUS,
    deDE,
];
export function supportedLocales() {
    return translations.map(prop('locale'));
}
export function isSupportedLocale(value) {
    return supportedLocales().includes(value);
}
export function guessLocale(locale) {
    if (!locale) {
        return ensureDefined(translations[0]?.locale);
    }
    if (isSupportedLocale(locale)) {
        return locale;
    }
    const languageOnly = ensureDefined(locale.split('-')[0]);
    const languageMatch = translations
        .find(t => t.locale.startsWith(languageOnly));
    if (languageMatch) {
        return languageMatch.locale;
    }
    return ensureDefined(translations[0]?.locale);
}
export function translation(lang) {
    const exactMatch = translations.find(({ locale }) => locale === lang);
    assertDefined(exactMatch);
    return exactMatch;
}
// temporary workaround for missing locale in user
export function guessLocaleFromLanguages(langs) {
    const locales = langs.map(guessLocale);
    if (locales.includes('de-DE')) {
        return 'de-DE';
    }
    return locales[0] ?? 'en-US';
}
// temporary workaround for missing locale in user
export function localeToLanguages(locale) {
    return [locale.split('-')[0] ?? 'de'];
}
//# sourceMappingURL=translation.js.map